<template>
  <div id="projects" class="col w-100 main-center cross-center section dark">
    <h2>My Projects</h2>
    <h3>Personal Projects</h3>
    <div class="row wrap main-space-around">
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-1-1"></div>
        <div>
          <h3>Vaishnava App</h3>
          <p>Vaishnava App is a useful tool, including calendar and books, for Sri Chaitanya Saraswat Math lovers.</p>
          <p><strong>HTML | CSS | JS | Vue</strong></p>
          <div class="row wrap">
            <a href="https://www.github.com/scsmathapp/vaishnava" target="_blank" class="clickable row main-center">View Source</a>
            <a href="https://scsmathapp.github.io/vaishnava" target="_blank" class="clickable row main-center">View Live App</a>
          </div>
        </div>
      </article>
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-1-2"></div>
        <div>
          <h3>Bike Shooter</h3>
          <p>An action pack shooting game with bikes.</p>
          <p><strong>HTML | CSS | JS</strong></p>
          <div class="row wrap">
            <a href="https://www.github.com/suyashfowdar/bike-shooter" target="_blank" class="clickable row main-center">View Source</a>
            <a href="https://suyashfowdar.github.io/bike-shooter" target="_blank" class="clickable row main-center">View Live App</a>
          </div>
        </div>
      </article>
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-1-3"></div>
        <div>
          <h3>Suyash Fowdar</h3>
          <p>Quality and software oriented personal portfolio project.</p>
          <p><strong>HTML | CSS | JS | Vue</strong></p>
          <div class="row wrap layout-padding8">
            <a href="https://www.github.com/suyashfowdar/SuyashFowdar.github.io" target="_blank" class="clickable row main-center">View Source</a>
            <div>Currently running...</div>
          </div>
        </div>
      </article>
    </div>
    <h3>Practical Projects</h3>
    <div class="row wrap main-space-around">
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-2-1"></div>
        <div>
          <h3>Krishna Shop</h3>
          <p>An online shop project for Gaudiya Tradition lovers.</p>
          <p><strong>HTML | CSS</strong></p>
          <div class="row wrap">
            <a href="https://www.github.com/suyashfowdar/Krishna_Shop" target="_blank" class="clickable row main-center">View Source</a>
            <a href="https://suyashfowdar.github.io/Krishna_Shop" target="_blank" class="clickable row main-center">View Live App</a>
          </div>
        </div>
      </article>
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-2-2"></div>
        <div>
          <h3>Tech News</h3>
          <p>An article page project for tech updates.</p>
          <p><strong>HTML | CSS | Ruby | Rails</strong></p>
          <div class="row wrap">
            <a href="https://www.github.com/suyashfowdar/tech-news" target="_blank" class="clickable row main-center">View Source</a>
            <a href="https://guarded-reaches-31670.herokuapp.com/" target="_blank" class="clickable row main-center">View Live App</a>
          </div>
        </div>
      </article>
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-2-3"></div>
        <div>
          <h3>Meow</h3>
          <p>An image gallery for cat lovers.</p>
          <p><strong>HTML | CSS | JS | React</strong></p>
          <div class="row wrap">
            <a href="https://www.github.com/suyashfowdar/meow" target="_blank" class="clickable row main-center">View Source</a>
            <a href="https://suyashfowdar.github.io/meow" target="_blank" class="clickable row main-center">View Live App</a>
          </div>
        </div>
      </article>
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-2-4"></div>
        <div>
          <h3>Baby Tracker</h3>
          <p>Mobile web app for tracking baby measurements.</p>
          <p><strong>HTML | CSS | JS | React | Ruby | Rails</strong></p>
          <div class="row wrap">
            <a href="https://www.github.com/suyashfowdar/baby-tracker-front" target="_blank" class="clickable row main-center">View Source</a>
            <a href="https://suyashfowdar.github.io/baby-tracker-front" target="_blank" class="clickable row main-center">View Live App</a>
          </div>
        </div>
      </article>
    </div>
    <h3>Professional Projects</h3>
    <div class="row wrap main-space-around">
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-3-1"></div>
        <div>
          <h3>Money ID</h3>
          <p>World’s first digital financial passport and SaaS application certified by KPMG.</p>
          <p><strong>AngularJS | NodeJS | MongoDB</strong></p>
          <div class="row wrap layout-padding8">
            <a href="https://www.planetoffinance.com/" target="_blank" class="clickable row main-center">Planet of Finance</a>
            <div>[ Inactive ]</div>
          </div>
        </div>
      </article>
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-3-2"></div>
        <div>
          <h3>Event Manager App</h3>
          <p>Internal Application for Adwaita Events Ltd for managing Events, Clients and Trainings.</p>
          <p><strong>VueJS | NativeScript | NodeJS | MongoDB</strong></p>
          <div class="row wrap layout-padding8">
            <a href="https://www.facebook.com/adwaitafiveaside" target="_blank" class="clickable row main-center">Adwaita Events Page</a>
            <div>[ Private ]</div>
          </div>
        </div>
      </article>
      <article class="row w-45-lg w-90-sm shadow-15 cross-center">
        <div class="img work-3-3"></div>
        <div>
          <h3>Delegate Tracking App</h3>
          <p>App to track products and delegate reportings taking into consideration geographical position and work time.</p>
          <p><strong>VueJS | Flutter | NodeJS | MongoDB</strong></p>
          <div class="row wrap layout-padding8">
            <a href="https://www.hyperpharm.mu/" target="_blank" class="clickable row main-center">Hyperpharm</a>
            <div>[ Private ]</div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Projects'
}
</script>
<style lang="scss" scoped>
$sm:('-sm', 0, 600px);
$lg:('-lg', 601px, 4000px);

@mixin sm {
	@media screen and (min-width: nth($sm, 2)) and (max-width: nth($sm, 3)) {
		@content;
	}
}

@mixin lg {
	@media screen and (min-width: nth($lg, 2)) and (max-width: nth($lg, 3)) {
		@content;
	}
}

.section {
  min-height: calc(100vh - 40px);

  h3 {
    font-size: 22px;
  }

  & > div {
    margin: 40px 0;

    article {
      border-radius: 5px;

      & > div:last-child {
        padding: 10px;
      }

      @include lg {
        margin: 20px 2vw;
      }

      @include sm {
        margin: 4vw;
      }
      
      a {
        padding: 8px;
      }
    }
  }

  .img {
    background-size: cover;
    background-repeat: no-repeat;
    min-width: calc(50px + 10vw);
    max-width: calc(50px + 10vw);
    height: 100%;
    border-radius: 5px 0 0 5px;
    
    &.work-3-1 {
      background-image: url(../assets/img/money-id.jpeg);
    }
    
    &.work-3-2 {
      background-image: url(../assets/img/adwaita.jpg);
    }
    
    &.work-1-3 {
      background-image: url(../assets/img/suyash.png);
    }
    
    &.work-1-1 {
      background-image: url(../assets/img/vaishnava.png);
    }
    
    &.work-2-1 {
      background-image: url(../assets/img/krishna-shop.png);
    }
    
    &.work-2-2 {
      background-image: url(../assets/img/tech-news.png);
    }
    
    &.work-3-3 {
      background-image: url(../assets/img/hyperpharm.png);
    }
    
    &.work-1-2 {
      background-image: url(../assets/img/bike-shooter.png);
      background-position-x: 80%;
    }
    
    &.work-2-3 {
      background-image: url(../assets/img/meow.png);
    }
    
    &.work-2-4 {
      background-image: url(../assets/img/baby-tracker.png);
    }
  }
}
</style>